export default "__VITE_ASSET__T6klPqL5HaqCH5EiYrl3Bw__"